import React, { Fragment } from "react";
import { Row, Card, CardBody, CardTitle, Badge } from "reactstrap";
import IntlMessages from "Util/IntlMessages";

import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";

function timeline() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.timeline" />}
            />
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        <Card className="mb-4">
          <CardBody>
            <CardTitle>
              <IntlMessages id="menu.timeline" />
            </CardTitle>
            <div>
              <Colxx lg="12">
                <Row>
                  <Colxx lg="6">
                    <div className="border-left-timeline ml-3">
                      <span className="fa fa-heart timeline-icon font-color-1" />
                      <div className="ml-3">
                        <Badge color="primary" className="timeline-date">
                          10/March/2019
                        </Badge>
                        <h6 className="mt-1">Premium Account</h6>
                        <p>We have lauched our premium account</p>
                      </div>

                      {/* New Part */}

                      <span className="fa fa-handshake timeline-icon font-color-1" />

                      <div className="ml-3">
                        <Badge color="primary" className="timeline-date">
                          09/March/2019
                        </Badge>
                        <h6 className="mt-1">Mathew Joined</h6>
                        <p>Mathew just joined our team</p>
                      </div>

                      {/* New Part */}

                      <span className="fa fa-handshake timeline-icon font-color-1" />

                      <div className="ml-3">
                        <Badge color="primary" className="timeline-date">
                          09/March/2019
                        </Badge>
                        <h6 className="mt-1">Mathew Joined</h6>
                        <p>Mathew just joined our team</p>
                      </div>
                    </div>
                  </Colxx>

                  <Colxx lg="6">
                    <div className="border-left-timeline ml-3">
                      <span className="fa fa-handshake timeline-icon font-color-1" />

                      <div className="ml-3">
                        <Badge color="primary" className="timeline-date">
                          09/March/2019
                        </Badge>
                        <h6 className="mt-1">Mathew Joined</h6>
                        <p>Mathew just joined our team</p>
                      </div>

                      {/* New Part */}

                      <span className="fa fa-handshake timeline-icon font-color-1" />

                      <div className="ml-3">
                        <Badge color="primary" className="timeline-date">
                          09/March/2019
                        </Badge>
                        <h6 className="mt-1">Mathew Joined</h6>
                        <p>Mathew just joined our team</p>
                      </div>

                      {/* New Part */}

                      <span className="fa fa-handshake timeline-icon font-color-1" />

                      <div className="ml-3">
                        <Badge color="primary" className="timeline-date">
                          09/March/2019
                        </Badge>
                        <h6 className="mt-1">Mathew Joined</h6>
                        <p>Mathew just joined our team</p>
                      </div>
                    </div>
                  </Colxx>
                </Row>
              </Colxx>
            </div>
          </CardBody>
        </Card>
      </Fragment>
    );
}

export default timeline;
